import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=3ab397a4"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab397a4')) {
      api.createRecord('3ab397a4', component.options)
    } else {
      api.reload('3ab397a4', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=3ab397a4", function () {
      api.rerender('3ab397a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Pages/UserProfile.vue"
export default component.exports